import { render, staticRenderFns } from "./WirelessKeyboardIcon.vue?vue&type=template&id=156244a6&scoped=true"
import script from "./WirelessKeyboardIcon.vue?vue&type=script&lang=js"
export * from "./WirelessKeyboardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156244a6",
  null
  
)

export default component.exports